import { createSelector } from 'reselect';

export const getBarcodeManufacturers = (state) => state.barcodeManufacturers.data;

export const getBarcodeManufacturersFormatted = createSelector(
  getBarcodeManufacturers,
  (items) => items.map(({ manufacturer_name: name, manufacturer_id: id }) => ({ name, id })),
);

export const getBarcodeManufacturersOptions = createSelector(
  getBarcodeManufacturersFormatted,
  (items) => items.map(({ name, id }) => ({ value: id, text: name })),
);
export const getBarcodeManufacturersLoadingState = ({ barcodeManufacturers }) => barcodeManufacturers.loading;
